/**
 * @generated SignedSource<<0e54fa97cc4cae30ebe11e7c1337ea7c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateGenderCriteriaInput = {
  clientMutationId?: string | null | undefined;
  genderIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useGenderCriteriaMutation$variables = {
  input: UpdateGenderCriteriaInput;
};
export type useGenderCriteriaMutation$data = {
  readonly updateGenderCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useGenderCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useGenderCriteriaMutation = {
  response: useGenderCriteriaMutation$data;
  variables: useGenderCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGenderCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateGenderCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateGenderCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useGenderCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useGenderCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateGenderCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateGenderCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "GENDER_BY_GENDER_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "GenderCriterionConnection",
                    "kind": "LinkedField",
                    "name": "genderCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GenderCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "genderId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "genderCriteria(orderBy:[\"GENDER_BY_GENDER_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c52189f298cc0875426306c11b7bb9a4",
    "id": null,
    "metadata": {},
    "name": "useGenderCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useGenderCriteriaMutation(\n  $input: UpdateGenderCriteriaInput!\n) {\n  updateGenderCriteria(input: $input) {\n    query {\n      ...useGenderCriteria_query\n      id\n    }\n  }\n}\n\nfragment useGenderCriteria_query on Query {\n  currentUser {\n    genderCriteria(orderBy: [GENDER_BY_GENDER_ID__SEQUENCE_ASC]) {\n      nodes {\n        genderId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f967c396a01355bd31475797766f77ac";

export default node;
